import { Container, DisplayObject } from "pixi.js";

export type MaxSize = {width: number, height: number};

export function ImplementBoundedContainer(asset: Container<DisplayObject>, maxSize: MaxSize, update: boolean=false,  debug: boolean=false): BoundedContainer {
    const newContainer = new BoundedContainer(maxSize);
    newContainer.x = asset.x;
    newContainer.y = asset.y;
    asset.x = asset.y = 0;

    if (asset.parent) {
        asset.parent.addChild(newContainer);
    }
    newContainer.addChild(asset);

    if (update) {

        newContainer.update(debug);
    }

    return newContainer;
}

export class BoundedContainer extends Container {
    _maxSize: MaxSize;

    set maxSize(value: MaxSize) {
        this._maxSize = value;
    }

    get maxSize() {
        return this._maxSize;
    }

    constructor(maxSize: MaxSize) {
        super();
        this._maxSize = maxSize;
    }

    update(debug:boolean = false) {
        this.scale.set(1);
        const heightRatio = Math.max(1, this.width / this._maxSize.width);
        const widthRatio = Math.max(1, this.height / this._maxSize.height);
        const ratio = Math.max(1, widthRatio, heightRatio);
        this.scale.set(1 / ratio, 1 / ratio);

        if (debug) {
            console.log(`BOUNDED CONTAINER UPDATE\n====================\n New scale -> (${this.scale.x}, ${this.scale.y})`);
        }
    }
}